// import EventHub from '@/utils/EventHub'

export default
{
    name: 'API',

    data()
    {
        return {

        }
    },

    created()
    {

    },

    mounted()
    {

    },

    destroyed()
    {

    },

    methods: {
        fetchUrl(endpoint, callback)
        {
            fetch(process.env.VUE_APP_WP_API + endpoint)
                .then((res) => res.json())
                .then((res) =>
                {
                    console.log('API FETCH : ', res)

                    if(callback)
                    {
                        callback(res)
                    }
                })
        },

        fetchMultipleUrls(endpoints, callback)
        {
            let resObj = {}

            endpoints = endpoints.map((endpoint) => {
                return {
                    label: endpoint.label,
                    path: endpoint.path,
                    url: `${process.env.VUE_APP_WP_API}${endpoint.url}`
                }
            })

            const allFetch = endpoints.map((endpoint) => {
                return fetch(endpoint.url)
                    .then(res => res.json())
                    .then(res => {

                        if(endpoint.path)
                        {
                            let finalObj = this.content.acf

                            for(let i = 0; i < endpoint.path.length; i++)
                            {
                                finalObj = finalObj[endpoint.path[i]]
                            }

                            finalObj.acf = res.acf

                        }
                        else if(endpoint.label)
                        {
                            resObj[endpoint.label] = res
                        }
                        else
                        {
                            resObj = res
                        }

                        return resObj
                    })
            })

            Promise.all(allFetch)
            .then(allres => {
                if(this.content)
                {
                    this.content = Object.assign(this.content, ...allres)
                }
                else
                {
                    this.content = Object.assign({}, ...allres)
                }

                console.log('API FETCH MULTIPLE : ', this.content)

                if(callback)
                {
                    callback(this.content)
                }
            })
        }
    }
}
